import React, { useEffect, useState } from 'react'
import config from '../coreFIles/config';
import toast, { Toaster } from 'react-hot-toast';
import Header from '../directives/header';
import Footer from '../directives/footer';
import Sidebar from '../directives/sidebar';
import ReactDatatable from '@ashvin27/react-datatable';
import { Link } from 'react-router-dom';
import moment from 'moment';
import {getGeneralPaymentsListAction } from '../Action/action'
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
const loginData = (!Cookies.get('loginSuccessBondiAdmin')) ? [] : JSON.parse(Cookies.get('loginSuccessBondiAdmin'));

const Generalpayments = () => {
	const [generalPaymentList, setGeneralPaymentList]	= useState([]);
	
	useEffect(() => {
		if (!loginData?.email) {
			window.location.href = `${config.baseUrl}login`
		}
		
		getGeneralPaymentlist();
	}, [])
	
	const getGeneralPaymentlist = async () => {
		let res = await getGeneralPaymentsListAction();
		if (res.success) {
			let data = res.data;
			setGeneralPaymentList(data);
		}
		else
		{
			setGeneralPaymentList([]);
		}
	}
	
	const columns = [
		{
			key: "Sno.",
			text: "#",
			cell: (row, index) => index + 1,
		},
		{
			key: "id",
			text: "Payment ID"
		},
		{
			key: "member_name",
			text: "Member Name",
			cell: (item) => {
				return (
					<>
						{ item.member_id && item.member_name ?
							<Link to={`${config.baseUrl}edit-user/${item.member_id}`} >
								{item.member_name}
							</Link>
							: <span>Guest User</span>
						}
					</>
				)
			}
		},
		{
			key: "member_email",
			text: "Email",
			cell: (item) => {
				return (
					<>
						{ item.member_email || '-' }
					</>
				)
			}
		},
		{
			key: "amount",
			text: "Amount",
			cell: (item) => {
				return (
					<>
						${item.amount || 0}
					</>
				)
			}
		},
		{
			key: "currency",
			text: "Currency"
		},
		{
			key: "payment_status",
			text: "Status",
			cell: (item) => {
				const status = item.payment_status || 'pending';
				const statusColor = status === 'succeeded' ? 'success' : status === 'failed' ? 'danger' : 'warning';
				return (
					<>
						<span className={`badge bg-${statusColor}`}>
							{status.charAt(0).toUpperCase() + status.slice(1)}
						</span>
					</>
				)
			}
		},
		{
			key: "txn_id",
			text: "Transaction ID",
			cell: (item) => {
				return (
					<>
						{ item.txn_id || '-' }
					</>
				)
			}
		},
		{
			key: "received_on",
			text: "Date",
			cell: (item) => {
				return (
					<>
						{ item.received_on != "" ? moment(item.received_on).format('DD/MM/YYYY HH:mm') : '-' }
					</>
				)
			}
		},
		{
			key: "payment_description",
			text: "Description",
			cell: (item) => {
				return (
					<>
						{ item.payment_description || '-' }
					</>
				)
			}
		}
	];

	const configForTable = {
		page_size: 10,
		length_menu: [10, 20, 50],
		show_filter: true,
		show_pagination: true,
		pagination: "advance",
		button: {
		excel: false,
		print: false,
		},
	};

	return (
		<>
			<div className="wrapper">
				<Toaster />
				<Header />
				<Sidebar />
				<div className="content-wrapper">
					<div className="container-full">
						{/* Main content */}
						<div className="content-header">
							<div className="d-flex align-items-center">
								<div className="me-auto">
									<h3 className="page-title mb-3 mb-md-5 pb-2">General Payments</h3>
								</div>
							</div>
							<hr />
						</div>
						<section className="content">
							<div className="row">
								<div className="col-lg-12 col-12">
									<div className="box">
									<div className="box-header with-border">
										<div className="row mb-15 align-items-center">
											<h4 className="box-title col-12 mb-2 mb-md-0">General Payments ({generalPaymentList.length})</h4>
										</div>
									</div>
										
									<div className="box-body">
										<div className="table-responsive" style={{ overflowX: 'auto' }}>
											<ReactDatatable
												config={configForTable}
												records={generalPaymentList}
												columns={columns}
											/>
										</div>
									</div>
									</div>
								</div>
							</div>
						</section>                       
					</div>
				</div>      	
				<Footer />
			</div>
		</>
	)
}
export default Generalpayments;

